import type { ReduxAction } from '@app/types';
import { AppState } from '@reducers/rootReducer';

export type UserMetadataFlag =
  | 'nexusCalloutDismissed'
  | 'requestBirthdaysCalloutDismissed'
  | 'accountProcessingToastDismissed'
  | 'forceShowImportingContactsAlert'
  | 'disableNoteReminderParsing'
  | 'showNotesInSidebar';

export type DefaultReminderTime = { hour: number; minute: number };

export type UserMetadata = Record<UserMetadataFlag, boolean> & {
  defaultReminderTime?: DefaultReminderTime;
};

export const initialDefaultReminderTime = { hour: 8, minute: 0 };

const initialUserMetadataState = {
  nexusCalloutDismissed: true,
  requestBirthdaysCalloutDismissed: true,
  accountProcessingToastDismissed: true,
  forceShowImportingContactsAlert: false,
  disableNoteReminderParsing: false,
  showNotesInSidebar: false,
  defaultReminderTime: initialDefaultReminderTime,
};

export const selectUserHasFlag = (flag: UserMetadataFlag) => (state: AppState) =>
  state.user.metadata[flag] === true;
export const selectDefaultReminderTime = (state: AppState) =>
  state.user.metadata.defaultReminderTime || initialDefaultReminderTime;
export const selectUserMetadata = (state: AppState) => state.user.metadata;

export function userMetadataReducer(
  state: UserMetadata = initialUserMetadataState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'FETCH_USER_METADATA_SUCCEEDED':
      return payload.response?.metadata;

    case 'UPDATE_USER_METADATA':
      return { ...state, ...payload };

    default:
      return state;
  }
}
